import { OutcomeAssessmentTable } from "./OutcomeAssessmentTable";

import { useFetchAndSelectMyAssessments } from "components/materials/section/assessment/assessment-data";
import { t } from "i18n/i18n";
import { useAppSelector } from "store/index";
import {
  NestedSectionOutcomeType,
  selectCurrentSectionId,
  selectCurrentUserId,
  selectPagesWithAssessmentsForSectionOutcomeAndUser,
} from "store/selectors";
import { useListSelector } from "store/store-hooks";

/**
 * Displays a list of all pages that are attached to the course outcome
 */
export const StudentOutcomeUseIndex = ({
  sectionOutcome,
}: {
  sectionOutcome: NestedSectionOutcomeType;
}) => {
  const userId = useAppSelector(selectCurrentUserId);
  const sectionId = useAppSelector(selectCurrentSectionId);
  const pageAssessmentsForSectionOutcome = useListSelector((s) =>
    selectPagesWithAssessmentsForSectionOutcomeAndUser(s, sectionOutcome.id, userId, sectionId),
  );

  useFetchAndSelectMyAssessments();

  return (
    <OutcomeAssessmentTable
      data={pageAssessmentsForSectionOutcome}
      title={t("assessment_dashboard.student_outcome_page_list.title")}
    />
  );
};
